import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import s from "./ChangePasswordDialog.module.scss";
import OutlinedText from "components/Input/OutlinedText/OutlinedText";
import { validateStrongPassword } from "utils/utils";
import StrongPasswordPopper from "components/StrongPasswordPopper/StrongPasswordPopper";
import { Typography } from "@mui/material";

const DIALOG_LOCALE_KEY = "page.dialogs.";

const ChangePasswordDialog = ({ userId, updatePayload }) => {
  const { t } = useTranslation();
  const [focus, setFocus] = useState({});
  const [error, setError] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const INPUT_FIELD_INIT_STATE = {
    id: userId,
    newPassword: "",
  };

  const [fieldInput, setFieldInput] = useState(INPUT_FIELD_INIT_STATE);

  const passwordInputOnChange = (e, field) => {
    const { value } = e.target;
    setError(false);
    setFieldInput({ ...fieldInput, [field]: value });
    if (validateStrongPassword(value)) {
      updatePayload({ ...fieldInput, [field]: value });
    } else {
      updatePayload({ ...fieldInput, [field]: "" });
    }
  };

  const textInputOnFocus = (field) => {
    setFocus({ [field]: true });
  };

  const textInputOnBlur = (field, callback) => {
    if (fieldInput[field] && callback) {
      const isValidValue = callback(fieldInput[field]);
      if (!isValidValue) {
        setError(true);
      }
    }
    setFocus({ [field]: false });
  };

  return (
    <div className={s.contentContainer}>
      <OutlinedText
        type="password"
        label={t(DIALOG_LOCALE_KEY + "changePassword.newPassword.label")}
        placeholder={t(
          DIALOG_LOCALE_KEY + "changePassword.newPassword.placeholder",
        )}
        value={fieldInput.newPassword}
        onchangeFn={(e) => passwordInputOnChange(e, "newPassword")}
        onfocusFn={(e) => {
          textInputOnFocus("newPassword");
          setAnchorEl(e.target);
        }}
        onblurFn={() => textInputOnBlur("newPassword", validateStrongPassword)}
        sxParams={{
          textFocus: focus.newPassword,
          textError: error,
        }}
        errorMessage={t(
          DIALOG_LOCALE_KEY + "changePassword.newPassword.errorInputStrong",
        )}
      />
      <Typography variant="content">
        {t(DIALOG_LOCALE_KEY + "changePassword.newPassword.requirement.unique")}
      </Typography>
      <StrongPasswordPopper
        open={focus.newPassword}
        anchorEl={anchorEl}
        password={fieldInput.newPassword}
      />
    </div>
  );
};

export default ChangePasswordDialog;
